export default __webpack_public_path__ + "static/media/i_bookmark.2173b764.png";